export const DEFAULT_STARTER = {
  python: 'print("Hello, World!")',
  c: `#include <stdio.h>

int main()
{
    printf("Hello World\\n");
    return 0;
}`,
  cpp: `#include <iostream>
using namespace std;

int main() {
    cout << "Hello, World!" << endl;
    return 0;
}`,
  java: `public class Main {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}`,
  // Empty so students can use Emmet `!` + Tab (VS Code style).
  html: '',
  css: `/* Write your CSS here */
body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 1rem;
}

.box {
    padding: 1rem;
    border: 1px solid #ccc;
}`,
  javascript: 'console.log("Hello, World!");',
};

export const LANGUAGE_TEMPLATES = {
  c: `#include <stdio.h>

int main()
{

    return 0;
}`,
  cpp: `#include <iostream>
using namespace std;

int main() {

    return 0;
}`,
  java: `public class Main{
    public static void main(String[] args){

    }
}`,
  python: `def main():
    pass

if __name__ == "__main__":
    main()`,
  javascript: `function main(){

}

main();`,
  typescript: `function main(): void {

}

main();`,
  html: '',
  css: `/* Write your CSS here */
body {
    font-family: Arial, sans-serif;
}`,
  go: `package main

import "fmt"

func main() {

}`,
  rust: `fn main() {

}`,
};

export function normalizeLanguage(language) {
  return String(language || 'python').toLowerCase();
}

export function normalizeStarterCode(starterCode = {}) {
  const normalized = { ...DEFAULT_STARTER };

  Object.entries(starterCode || {}).forEach(([key, value]) => {
    const lang = normalizeLanguage(key);
    if (value != null && String(value).trim() !== '') {
      normalized[lang] = String(value);
    }
  });

  return normalized;
}

export function getLanguageTemplate(language) {
  const lang = normalizeLanguage(language);
  return LANGUAGE_TEMPLATES[lang] || DEFAULT_STARTER[lang] || '';
}

export function resolveStarterCode(language, starterCode = {}) {
  const lang = normalizeLanguage(language);
  const merged = normalizeStarterCode(starterCode);
  return merged[lang] || getLanguageTemplate(lang) || '';
}

export function shouldApplyTemplate(currentCode, starterCode = {}) {
  const trimmed = (currentCode || '').trim();
  if (!trimmed) return true;

  const merged = normalizeStarterCode(starterCode);
  const allKnown = [
    ...Object.values(LANGUAGE_TEMPLATES),
    ...Object.values(DEFAULT_STARTER),
    ...Object.values(merged),
  ];

  return allKnown.some((template) => String(template).trim() === trimmed);
}
